import React from 'react';
import carlosB64 from '../../assets/origem-carlos.webp.b64?raw';

const carlosPhoto = `data:image/webp;base64,${carlosB64.trim()}`;
const luenePhoto = '/luene-home.jpeg';

const Origin = () => (
  <section className="bg-paper-alt py-20 md:py-28 px-4" aria-labelledby="origem-title">
    <div className="max-w-6xl mx-auto grid lg:grid-cols-[0.95fr_1.05fr] gap-12 lg:gap-20 items-center">
      <div className="grid grid-cols-2 gap-4 items-end">
        <figure>
          <img
            src={carlosPhoto}
            width="420"
            height="525"
            loading="lazy"
            alt="Dr. Carlos Felipe, cofundador do Laudando Online"
            className="w-full aspect-[4/5] object-cover object-center rounded-card border border-line"
          />
          <figcaption className="mt-3"><p className="text-sm font-semibold text-ink">Dr. Carlos Felipe</p></figcaption>
        </figure>
        <figure>
          <img
            src={luenePhoto}
            width="768"
            height="1376"
            loading="lazy"
            alt="Dra. Luene Gomes, cofundadora do Laudando Online"
            className="w-full aspect-[4/5] object-cover object-[50%_22%] rounded-card border border-line"
          />
          <figcaption className="mt-3"><p className="text-sm font-semibold text-ink">Dra. Luene Gomes</p></figcaption>
        </figure>
      </div>

      <div>
        <h2 id="origem-title" className="font-display text-3xl md:text-5xl font-bold tracking-[-0.025em] text-navy mb-6">
          O Laudando nasceu do lado de quem <em className="font-semibold text-selo">precisa emitir.</em>
        </h2>
        <div className="space-y-4 text-base md:text-lg leading-relaxed text-muted max-w-xl">
          <p>Eu conheço a rotina em que o laudo começa procurando um modelo antigo, conferindo cabeçalho, corrigindo formatação e tentando lembrar onde ficou a última versão. O problema nunca foi escrever medicina; era todo o trabalho ao redor do documento.</p>
          <p>O Laudando nasceu para deixar modelo, identidade profissional, local, histórico e validação no mesmo fluxo. O que funciona em um laudo fica disponível no próximo, sem transformar a emissão em mais um sistema pesado para administrar.</p>
          <p className="text-ink font-medium">Criado por Dr. Carlos Felipe, CRM-MG 105.721, e Dra. Luene Gomes.</p>
        </div>
      </div>
    </div>
  </section>
);

export default Origin;
